<template>
  <mdb-container>
    <mdb-row>
      <mdb-col>
        <Errors v-show="!!error" :error="error" />
        <div v-show="showSpinner">
          <Spinner />
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-tbl striped borderless class="wide">
        <mdb-tbl-head>
          <tr>
            <th>Name</th>
            <th>Asset Type</th>
            <th>Scan Key</th>
            <th>Active</th>
            <th>Created On</th>
            <th>Action</th>
          </tr>
        </mdb-tbl-head>

        <transition-group tag="tbody" name="fade">
          <tr v-for="asset in assetList.rows" :key="asset.id">
            <td>{{ asset.name }}</td>
            <td>{{ asset.asset_type }}</td>
            <td>{{ asset.scan_key }}</td>
            <td>{{ asset.active }}</td>
            <td>{{ asset.created_at | formatDate }}</td>
            <td>
              <mdb-btn
                color="dark"
                v-on:click="removeAsset(asset)"
                outline="primary"
                icon="minus"
                size="sm"
                >Remove</mdb-btn
              >
            </td>
          </tr>
        </transition-group>
      </mdb-tbl>
    </mdb-row>

    <mdb-row>
      <mdb-modal :show="showDeleteModal" @close="showDeleteModal = false">
        <mdb-modal-header>
          <mdb-modal-title
            >Remove Asset ({{ selectedAsset.name }})
          </mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body
          >Do you want to permanently delete this asset?

          <strong>{{ selectedAsset.name }}</strong>
          <br />
          <strong
            >Asset Key: {{ selectedAsset.scan_key }}
          </strong> <br/><br/>
          <i> Note: This asset will no longer be recognized by scanning systems.</i>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn outline="primary" @click.native="showDeleteModal = false"
            >No</mdb-btn
          >
          <mdb-btn color="primary" v-on:click="deleteAsset()"
            >Yes, Delete</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import dateFns from "date-fns";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbTbl,
  mdbTblHead,
  mdbModal,
  mdbModalTitle,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalBody,
} from "mdbvue";
// import Spinner from "@/components/Spinner";

export default {
  name: "assetList",
  props: {
    assets: {
      type: Array,
      required: true,
    },
  },

  filters: {
    formatDate(date) {
      return dateFns.format(date, "MMMM Do [at] h:mm:ss a");
    },
  },

  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbModal,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    Spinner,
    Errors,
  },
  data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      selectedAsset: {},
      error: "",
      assetList: {
        rows: [],
      },
    };
  },
  created() {
    this.assetList.rows = this.assets;
    this.isLoading = false;
  },
  methods: {
    removeAsset(asset) {
      this.selectedAsset = asset;
      this.showDeleteModal = true;
    },

    deleteAsset() {
      this.isLoading = true;
      this.showDeleteModal = false;
      api
        .deleteAsset(this.selectedAsset.id)
        .then((response) => {
          this.assetList.rows = [...response.data];
          this.isLoading = false;
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
  },
  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
};
</script>

<style scoped lang="scss">
.wide {
  width: 80vw;
}
</style>
